//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fromItems from "./mixin/fromItems";
export default {
  mixins: [fromItems],
  name: "ykFormItem",
  props: {
    inline: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {},
  methods: {}
};